import dayjs from 'dayjs';

/**
 * Whole calendar days from `now` to the premiere date: 0 on the day itself,
 * negative once it has passed. Compared at day granularity so a premiere
 * "tomorrow at 00:00" reads as 1 regardless of the current hour.
 *
 * The list is scoped to future premieres, but the show page resolves past ones
 * too — hence the negative branch. `null` when the date is missing or invalid.
 */
export const daysUntilPremiere = (
  publishedAt: string | null | undefined,
  now: Date = new Date()
): number | null => {
  if (!publishedAt) return null;
  const premiere = dayjs(publishedAt);
  if (!premiere.isValid()) return null;
  return premiere.startOf('day').diff(dayjs(now).startOf('day'), 'day');
};

/** i18n key (under the resource's `countdown`) for a day count. */
export const countdownKey = (
  days: number
): 'past' | 'today' | 'tomorrow' | 'in_days' => {
  if (days < 0) return 'past';
  if (days === 0) return 'today';
  if (days === 1) return 'tomorrow';
  return 'in_days';
};
